import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { QueueForm } from "../-component/queue-form";
import { queueQueryOptions } from "@/server/queues";
import { QueueReadable } from "@/lib/mma/types.gen";
import { useEffect } from "react";

export const Route = createFileRoute("/_dashboard/queues/$queueId/edit")({
  component: RouteComponent,
  loader: async ({ params }) => {
    return { crumb: "Edit", params };
  },
});

function RouteComponent() {
  const { queueId } = Route.useParams();
  const queueQuery = useQuery(queueQueryOptions(Number(queueId)));
  const queue = queueQuery.data as QueueReadable;

  useEffect(() => {
    if (!queueId) return;
    void queueQuery.refetch();
  }, [queueId, queueQuery.refetch]);

  return <QueueForm queue={queue} isEdit={true} />;
}
